export default "__VITE_ASSET__BSEpQyT2__"